import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { motion } from 'framer-motion';

const StatCard = ({ title, value, icon, color = "emerald", subtitle }) => {
  const colorMap = {
    emerald: "bg-emerald-50 text-emerald-600 border-emerald-100",
    blue: "bg-blue-50 text-blue-600 border-blue-100",
    amber: "bg-amber-50 text-amber-600 border-amber-100",
    indigo: "bg-indigo-50 text-indigo-600 border-indigo-100"
  };

  return (
    <motion.div 
      whileHover={{ y: -4 }}
      className="bg-white p-6 rounded-2xl border border-gray-100 shadow-sm flex items-start gap-4"
    >
      <div className={`p-3 rounded-xl border ${colorMap[color] || colorMap.emerald}`}>
        <SafeIcon icon={icon} className="text-xl" />
      </div>
      <div>
        <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest mb-1">{title}</p>
        <h3 className="text-2xl font-black text-gray-900 leading-none">{value}</h3>
        {subtitle && <p className="text-xs text-gray-500 mt-2 font-medium">{subtitle}</p>}
      </div>
    </motion.div>
  );
};

export default StatCard;